module.exports = {
  api: {
    API_URL: "https://api.fort.exchange/api",
  }
};